module.exports = new __parcel__URL__("cartoon-network-logo.28351ab5.svg").toString();